module.exports = __webpack_public_path__ + "img/1958-5.59e30d0a.png";